import angular from "angular";

import { ApiValidationError, Onboarding } from "@salaxy/core";

import { OnboardingService, SessionService, UiHelpers, WizardService, WizardStep, SignatureService } from "../../../services";

import { WizardController } from "../../bases/WizardController";

/**
 * Wizard for Creating a new Palkkaus.fi-account (worker)
 */
export class WorkerOnboardingController extends WizardController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["$scope", "WizardService", "OnboardingService", "SessionService", "UiHelpers", "SignatureService"];

  /** Worker wizard configuration */
  public wizardSteps: WizardStep[] = [
    {
      title: "SALAXY.NG1.WorkerOnboardingComponent.stepUserInfo.title",
      heading: "SALAXY.NG1.WorkerOnboardingComponent.stepUserInfo.heading",
      intro: "",
      active: true,
      view: "salaxy-components/modals/onboarding/worker/user-info.html",
      buttonsView: "salaxy-components/modals/onboarding/worker/firstPageButtons.html",
    },
    /*
    {
      title: "SALAXY.NG1.WorkerOnboardingComponent.stepPhoneNumberVerify.title",
      heading: "SALAXY.NG1.WorkerOnboardingComponent.stepPhoneNumberVerify.heading",
      intro: "SALAXY.NG1.WorkerOnboardingComponent.stepPhoneNumberVerify.intro",
      view: "salaxy-components/modals/onboarding/worker/phonenumber-verify.html",
      buttonsView: "salaxy-components/modals/onboarding/worker/phoneNumberVerifyButtons.html",
    },
    */
    {
      title: "SALAXY.NG1.WorkerOnboardingComponent.stepContract.stepTitle",
      heading: "SALAXY.NG1.WorkerOnboardingComponent.stepContract.heading",
      intro: "SALAXY.NG1.WorkerOnboardingComponent.stepContract.intro",
      view: "salaxy-components/modals/onboarding/worker/contract-worker.html",
      buttonsView: "salaxy-components/modals/onboarding/worker/contractButtons.html",
    },
  ];

  /**
   * Field to expose forms validity state.
   */
  public formDataValidity: boolean;

  /** If true, step is proceeding */
  public isStepProceeding = false;

  public signatureMethods: any[];

  constructor(
    $scope: angular.IScope,
    wizardService: WizardService,
    private onboardingService: OnboardingService,
    private sessionService: SessionService,
    private uiHelpers: UiHelpers,
    private signatureService: SignatureService
  ) {
    super($scope, wizardService);
  }

   /**
    * Implement IController
    */
   public $onInit() {
    this.wizardService.setSteps(this.wizardSteps);
    this.wizardService.activeStepNumber = 1;
    this.getSignatureMethods();
  }

  /**
   * Navigates to the next step if possible and saves the data.
   */
  public goNext(): Promise<boolean> {
    if (this.isStepProceeding) {
      return Promise.resolve(false);
    }
    this.isStepProceeding = true;
    return this.save().then(() => {
      super.goNext();
      this.isStepProceeding = false;
      return true;
    }).catch((reason) => {
      this.isStepProceeding = false;
      return false;
    });
  }

  /** Returns true if user can go forward in wizard  */
  public get canGoNext(): boolean {
    if (this.steps.length > this.step) {
      if (this.steps[this.step] && !this.steps[this.step].disabled) {
        if (this.formDataValidity) {
          /* if (this.model.validation.isOfficialIdUnique == true){ */
          return true;
          /* } */
        }
      }
    }
    return false;
  }

  /** Runs a check function before going forward */

  public goNextIf(checkFunction: (goNext: () => Promise<boolean>) => void) {
    checkFunction(() => this.goNext());
  }

  /**
   * Navigates to the previous step if possible and saves the data.
   */
  public goPrevious() {
    if (this.isStepProceeding) {
      return;
    }
    this.isStepProceeding = true;
    this.save().then(() => {
      super.goPrevious();
      this.isStepProceeding = false;
    })
      .catch((reason) => {
        this.isStepProceeding = false;
      });
  }

  /**
   * Saves the data to server
   */
  public save(): Promise<Onboarding> {
    this.model.signature.email = this.model.person.contact.email;
    this.model.signature.telephone = this.model.person.contact.telephone;
    this.model.signature.personName = (this.model.person.firstName + " " + this.model.person.lastName).trim();
    return this.onboardingService.save();
  }

  /**
   * Returns signing url.
   */
  public get vismaSignUrl(): string {
    // HACK: Get rid of this: Use this.model.signature.digitalSignature.auth_service instead.
    const method = (this.model.signature as any).method;
    return this.onboardingService.getDigitalSignUrl(method);
  }

  /**
   * The onboarding model is provided by the onboarding service.
   */
  public get model(): Onboarding {
    return this.onboardingService.model;
  }

  /** Returns the PDF preview address for the authorization pdf. */
  public getPdfPreviewAddress() {
    return this.onboardingService.getPdfPreviewAddress();
  }

  /**
   * Returns validation error for key if exists.
   * @param key - Validation error key.
   */
  public getValidationError(key: string): ApiValidationError {
    if (this.model && this.model.validation) {
      return this.model.validation.errors.find((x) => x.key === key);
    }
    return null;
  }

  /**
   * Resets validation error for key if exists.
   * @param key - Validation error key.
   */
  public removeValidationError(key: string): void {
    if (this.model && this.model.validation) {
      (this.model.validation as any).errors = this.model.validation.errors.filter((x) => x.key !== key);
    }
  }

  /**
   * Checks if the given string is other identifier than Finnish Personal Identification Number
   * @param ssn given social security number
   */
  public isOtherIdentifier(ssn: string){

    /** 8th character is 9 */
    const regex = /^.{7}[9]/;
    return regex.test((ssn || "").trim());
  }

  /**
   * Launches the wizard.
   * @param id Optional onboarding id.
   */
  public launch(id: string = null): Promise<any> {
    return this.onboardingService.launchWorkerOnboarding(id);
  }

  private getSignatureMethods(): void {
    const signatureMethods = this.signatureService.getMethods("telia");

    this.signatureMethods = signatureMethods
      .map(method => ({
        value: method.value,
        label: method.title,
        imgSrc: method.img,
      }));
  }
}
